import React, { useState } from "react";
import { Link, RouterProps, useHistory } from "react-router-dom";
import {
  Center,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Flex
} from "@chakra-ui/react";

export const IncorrectCode = () => {
  return (
    <Center height="100%">
      <Alert
        status="error"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
        width="600px"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg" color="white">
          Code is incorrect
        </AlertTitle>
        <Flex direction={"column"}>
          <AlertDescription maxWidth="sm" color="white">
            Your Account activation code is incorrect.
          </AlertDescription>
          <AlertDescription maxWidth="sm" color="white">
            Please <Link to="/login"> Click here </Link> to try again.
          </AlertDescription>
        </Flex>
      </Alert>
    </Center>
  );
};
